export const httpsPrefixRegExp = /^(https?:)?\/\//i
